// frontend/src/index.js - Updated with PayPal Provider + Language + Notifications
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { NotificationProvider } from './components/NotificationContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PayPalScriptProvider options={{ "client-id": "AeOn5ROgv44GD2ncUY-rJWFXa8cB__8RPoT9xvuKTlTyVb5I6vzl1vFWDs1hST38OIBSilMRIG5RuB6O" }}>
      <LanguageProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </LanguageProvider>
    </PayPalScriptProvider>
  </React.StrictMode>
);

reportWebVitals();
